import { ref } from 'vue';

export interface CacheEntry<T> {
  value: T;
  updatedAt: string;
}

export const createEntityCache = <T>() => {
  const cache = ref<Map<string, CacheEntry<T>>>(new Map());

  const set = (key: string, value: T): void => {
    cache.value.set(key, {
      value,
      updatedAt: new Date().toISOString()
    });
  };

  const get = (key: string): T | undefined => {
    const entry = cache.value.get(key);
    return entry?.value;
  };

  const invalidate = (key?: string): void => {
    if (!key) {
      cache.value.clear();
      return;
    }
    cache.value.delete(key);
  };

  return {
    cache,
    set,
    get,
    invalidate
  };
};

export const generateEntityId = (prefix: string): string => {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }

  const randomSuffix = Math.random().toString(36).slice(2, 10);
  return `${prefix}-${randomSuffix}`;
};

